import angular from 'angular';
import constants from 'app/constants';
import IComplianceAppDataService from './IComplianceApp.data.service';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _upload;

class pmDataService extends IComplianceAppDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'pm', { settings: 'settings' });
    _upload = Upload;

    console.log('app.services.pmDataService created');

    // TODO: Remove mock data when PM-115 is completed
    this.mockEmptyVariables = [
      {
        createdDate: '2019-04-10T13:05:15.29',
        createdUserId: 1,
        customerId: 1,
        customerPolicyDocumentVariableId: 1,
        deletedDate: null,
        deletedUserId: null,
        displayName: 'Institution Name',
        isDefault: false,
        lastUpdatedDate: null,
        lastUpdatedUserId: null,
        masterDocumentVariableId: 1,
        name: 'institutionName',
        overriddenDate: null,
        overriddenUserId: null,
        policyDocumentId: 0,
        tag: 'Institution_Name',
        value: '',
      },
      {
        createdDate: '2019-04-10T13:05:15.29',
        createdUserId: 1,
        customerId: 1,
        customerPolicyDocumentVariableId: 2,
        deletedDate: null,
        deletedUserId: null,
        displayName: 'Core Provider Name',
        isDefault: false,
        lastUpdatedDate: null,
        lastUpdatedUserId: null,
        masterDocumentVariableId: 2,
        name: 'coreProviderName',
        overriddenDate: null,
        overriddenUserId: null,
        policyDocumentId: 0,
        tag: 'Core_Provider_Name',
        value: '',
      }
    ];
  }

  // #################################################################################################
  // VARIABLES

  getVariables() {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentVariable`,
      method: 'GET',
    });
  }

  saveVariables(variables) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentVariable/bulk`,
      method: 'POST',
      data: JSON.stringify(variables),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getEmptyVariables() {
    // TODO: Update and enable this call and remove mock data when PM-115 is completed
    // return this.$http({
    //   url: `${this.apiRootUrl}/pm/policyDocumentVariable/isCompleted`,
    //   method: 'GET',
    // });
    return Promise.resolve({
      data: {
        result: [] // this.mockEmptyVariables
      }
    });
  }

  // #################################################################################################
  // ENDNOTES

  getEndnotes(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/byDocument/${policyDocumentId}`,
      method: 'GET',
    });
  }

  addEndnote(policyDocumentEndNote, materialChange) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote`,
      method: 'POST',
      data: JSON.stringify({
        policyDocumentEndNote,
        materialChange,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  updateEndnote(policyDocumentEndNote, materialChange) {
    const { explanation, isMaterialChange } = materialChange;
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/${policyDocumentEndNote.policyDocumentEndNoteId}`,
      method: 'PUT',
      data: JSON.stringify({
        policyDocumentEndNote,
        explanation,
        isMaterialChange
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteEndnote(policyDocumentEndNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/${policyDocumentEndNoteId}`,
      method: 'DELETE',
    });
  }

  checkEndnoteTagExists(policyDocumentId, endNoteId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/checkExists`,
      method: 'GET',
      params: {
        documentId: policyDocumentId,
        id: endNoteId,
        displayName,
      }
    });
  }

  syncEndnoteToMaster(policyDocumentEndNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/${policyDocumentEndNoteId}/syncMaster`,
      method: 'PUT',
    });
  }

  denyMasterEndnoteChange(policyDocumentEndNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentEndNote/${policyDocumentEndNoteId}/desyncMaster`,
      method: 'PUT',
    });
  }

  // #################################################################################################
  // CHANGE LOG

  getChangeLog(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLog/byPolicyDocument/${policyDocumentId}`,
      method: 'GET',
    });
  }

  getChangeLogByCustomer() {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLog/byCustomer/`,
      method: 'GET',
    });
  }

  revertChange(changeLogItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLog/${changeLogItemId}/revert`,
      method: 'PUT',
    });
  }

  // #################################################################################################
  // POLICY DOCUMENT

  allowNewAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/allowNew`,
      method: 'GET',
    });
  }

  checkDocumentExists(documentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/checkExists`,
      method: 'GET',
      params: {
        name,
        id: documentId,
      },
    });
  }

  getPolicyDocuments() {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument`,
      method: 'GET',
    });
  }

  initPolicyManagement() {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/init`,
      method: 'GET',
    });
  }

  getPolicyDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}`,
      method: 'GET',
    });
  }

  savePolicyDocument(document) {
    if (document.policyDocumentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/pm/policyDocument/${document.policyDocumentId}`,
        method: 'PUT',
        data: JSON.stringify(document),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument`,
      method: 'POST',
      data: JSON.stringify(document),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  syncPolicyDocumentToMaster(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/syncToCurrentVersion`,
      method: 'POST',
      params: {}
    });
  }

  getDeniedMasterDocumentChanges(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/masterSectionSyncChangesDenied`,
      method: 'GET',
      params: {}
    });
  }

  getCompareToMasterDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/compareToMasterSections`,
      method: 'GET',
      params: {}
    });
  }

  getCompareToMasterSection(policyDocumentSectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSectionId}/compareToMasterSection`,
      method: 'GET',
      params: {}
    });
  }

  getMasterSectionSyncChanges(policyDocumentSectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSectionId}/masterSectionSyncChanges`,
      method: 'GET',
      params: {}
    });
  }

  getMasterSectionsSyncChanges(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/masterSectionSyncChanges`,
      method: 'GET',
      params: {}
    });
  }

  deletePolicyDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}`,
      method: 'DELETE',
    });
  }

  approveDocument(policyDocumentId, approvedById, approvalDate) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/boardApproved`,
      method: 'PUT',
      data: this.serializeData({
        approvedById,
        approvalDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  unapproveDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/unapprove`,
      method: 'PUT',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // #################################################################################################
  // SECTIONS

  getChangedSections(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/getChangedSections`,
      method: 'GET',
    });
  }

  getSections(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/byDocument/${policyDocumentId}`,
      method: 'GET',
      params: {
        echo: true,
        renderSubsections: true,
      },
    });
  }

  getSection(policyDocumentSectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSectionId}`,
      method: 'GET',
    });
  }

  getRenderedTopSection(policyDocumentSectionId, renderSubsections, renderDetails) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSectionId}/render`,
      method: 'PUT',
      params: {
        echo: true,
        renderSubsections,
        renderDetails,
      },
    });
  }

  addSection(policyDocumentSection, materialChange) {
    // Never send this property as it may break child relationships
    delete policyDocumentSection.policyDocumentSectionChildren;
    delete policyDocumentSection.render;
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection`,
      method: 'POST',
      data: JSON.stringify({
        policyDocumentSection,
        materialChange,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  updateSection(policyDocumentSection, materialChange) {
    // Never send this property as it may break child relationships
    const { explanation, isMaterialChange } = materialChange;
    delete policyDocumentSection.policyDocumentSectionChildren;
    delete policyDocumentSection.render;
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSection.policyDocumentSectionId}`,
      method: 'PUT',
      data: JSON.stringify({
        policyDocumentSection,
        explanation,
        isMaterialChange
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteSection(policyDocumentSectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${policyDocumentSectionId}`,
      method: 'DELETE',
    });
  }

  syncSectionToMaster(sectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${sectionId}/syncMaster`,
      method: 'PUT',
    });
  }

  syncSectionsToMaster(policyDocumentSectionIds) {
    const data = {
      policyDocumentSectionIds,
      echo: true,
    };
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/syncMasters`,
      method: 'POST',
      data: this.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  acceptSyncedChanges(changes) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/acceptSyncChanges`,
      method: 'PUT',
      data: JSON.stringify(changes),
    });
  }

  denySyncedChanges(changes) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/denySyncChanges`,
      method: 'PUT',
      data: JSON.stringify(changes),
    });
  }

  batchSyncSectionsToMaster(ids) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/syncMaster/batch`,
      method: 'PUT',
      params: {
        ids
      },
    });
  }

  syncSectionToNewMaster(syncMasterData) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/syncNewMaster`,
      method: 'PUT',
      data: JSON.stringify(syncMasterData),
    });
  }

  denyMasterSectionChange(sectionId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/${sectionId}/desyncMaster`,
      method: 'PUT',
    });
  }

  batchDenyMasterSectionChanges(ids) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSection/syncMasterDeny/batch`,
      method: 'PUT',
      params: {
        ids
      },
    });
  }

  // #################################################################################################
  // POLICY DOCUMENT DOCUMENTS --- DEPRACATED: DO NOT USE!

  getAttachment(documentAttachmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAttachment/${documentAttachmentId}`,
      method: 'GET',
      params: {}
    });
  }

  getAttachmentsByPolicyDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/attachment`,
      method: 'GET',
      params: {}
    });
  }

  checkSupportingDocumentDisplayNameExists(policyDocumentId, policyDocumentSupportingDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/supportingDocument/checkDisplayNameExists`,
      method: 'GET',
      params: {
        policyDocumentSupportingDocumentId,
        displayName,
      }
    });
  }

  checkSupportingDocumentFileNameExists(policyDocumentId, policyDocumentSupportingDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/supportingDocument/checkFileNameExists`,
      method: 'GET',
      params: {
        policyDocumentSupportingDocumentId,
        fileName,
      }
    });
  }

  uploadDocumentAttachment(policyDocumentId, attachment) {
    return _upload.upload({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/attachment/upload`,
      data: {
        policyDocumentId,
        policyDocumentAttachmentId: attachment.policyDocumentAttachmentId,
        displayValue: attachment.name,
        isDeletable: attachment.deletable,
        file: attachment.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteDocumentAttachment(documentAttachmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAttachment/${documentAttachmentId}`,
      method: 'DELETE',
    });
  }

  // #################################################################################################
  // POLICY DOCUMENT DOCUMENTS

  getSupportingDocument(documentSupportingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSupportingDocument/${documentSupportingDocumentId}`,
      method: 'GET',
      params: {}
    });
  }

  getSupportingDocumentsByPolicyDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/supportingDocument`,
      method: 'GET',
      params: {}
    });
  }

  checkDocumentSupportingDocumentExists(policyDocumentId, displayValue, documentSupportingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/supportingDocument/checkExists`,
      method: 'GET',
      params: {
        displayValue,
        documentSupportingDocumentId,
      },
    });
  }

  uploadDocumentSupportingDocument(policyDocumentId, supportingDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/supportingDocument/upload`,
      data: {
        policyDocumentId,
        policyDocumentSupportingDocumentId: supportingDocument.policyDocumentSupportingDocumentId,
        displayValue: supportingDocument.name,
        isDeletable: supportingDocument.deletable,
        file: supportingDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateDocumentSupportingDocument(supportingDocument) {
    /* eslint-disable */
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSupportingDocument/${supportingDocument.policyDocumentSupportingDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(supportingDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteDocumentSupportingDocument(documentSupportingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSupportingDocument/${documentSupportingDocumentId}`,
      method: 'DELETE',
    });
  }

  downloadAllDocumentSupportingDocuments(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentSupportingDocument/downloadAll/${policyDocumentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  // #################################################################################################
  // POLICY DOCUMENT ADDENDA

  getAddendum(documentAddendumId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAddenda/${documentAddendumId}`,
      method: 'GET',
      params: {}
    });
  }

  getAddendaByPolicyDocument(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/addenda`,
      method: 'GET',
      params: {}
    });
  }

  checkDocumentAddendumDisplayNameExists(policyDocumentId, policyDocumentAddendaId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/addenda/checkDisplayNameExists`,
      method: 'GET',
      params: {
        policyDocumentAddendaId,
        displayName,
      }
    });
  }

  checkDocumentAddendumFileNameExists(policyDocumentId, policyDocumentAddendaId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/addenda/checkFileNameExists`,
      method: 'GET',
      params: {
        policyDocumentAddendaId,
        fileName,
      }
    });
  }

  uploadDocumentAddendum(policyDocumentId, addendum) {
    return _upload.upload({
      url: `${this.apiRootUrl}/pm/policyDocument/${policyDocumentId}/addenda/upload`,
      data: {
        policyDocumentId,
        policyDocumentAddendaId: addendum.policyDocumentAddendaId,
        displayValue: addendum.name,
        isDeletable: addendum.deletable,
        file: addendum.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateDocumentAddendum(addendum) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAddenda/${addendum.policyDocumentAddendaId}`,
      method: 'PUT',
      data: JSON.stringify(addendum),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteDocumentAddendum(documentAddendumId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAddenda/${documentAddendumId}`,
      method: 'DELETE',
    });
  }

  downloadAllDocumentAddenda(policyDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/policyDocumentAddenda/downloadAll/${policyDocumentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  // #################################################################################################
  // DOCUMENT CHANGE LOG AUDIT

  getDocumentChangeLogAudit(documentChangeLogAuditId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLogAudit/${documentChangeLogAuditId}`,
      method: 'GET',
      params: {}
    });
  }

  getDocumentChangeLogAuditsByDocumentChangeLog(documentChangeLogId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLogAudit/byDocumentChangeLog/${documentChangeLogId}`,
      method: 'GET',
      params: {}
    });
  }

  saveDocumentChangeLogAudit(documentChangeLogAudit) {
    if (documentChangeLogAudit.documentChangeLogAuditId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/pm/documentChangeLogAudit/${documentChangeLogAudit.documentChangeLogAuditId}`,
        method: 'PUT',
        data: this.serializeData(documentChangeLogAudit),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLogAudit`,
      method: 'POST',
      data: this.serializeData(documentChangeLogAudit),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteDocumentChangeLogAudit(documentChangeLogAuditId) {
    return this.$http({
      url: `${this.apiRootUrl}/pm/documentChangeLogAudit/${documentChangeLogAuditId}`,
      method: 'DELETE',
    });
  }
}

pmDataService.$inject = [
  '$http',
  'Upload',
  'utilityService'
];

export default angular.module('app.services.pmDataService', [
  constants,
  ngFileUpload,
])
  .service('pmDataService', pmDataService)
  .name;
